import React from 'react'
import { refreshTokenIfExpired } from '@features/auth/utils/refresh-token-if-expired'
import axios from 'axios'
import { useLazyRevisionListRecordingsQuery } from '@app/services/auto-generated/revision'
import { API_BASE_URL } from '@config'

export const useStreamRecordingUnsw = (testMyself: boolean) => {
  const [isSuccess, setIsSuccess] = React.useState<boolean>(false)
  const [getRecordings] = useLazyRevisionListRecordingsQuery()
  let timeoutId: NodeJS.Timeout | null = null

  const uploadRecording = async (blob: Blob, chunkNumber: number, recordingId: string) => {
    const formData = new FormData()
    formData.append('file', blob, `recording_${chunkNumber}.wav`)
    const token = await refreshTokenIfExpired()
    await axios.post(
      `${API_BASE_URL}/api/v1/extensions/revision/record/upload_chunked_audio/${recordingId}/${chunkNumber}?live_transcribe=true&is_exam_mode=true`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
  }
  const stopUploadRecording = async (recordingId: string) => {
    setIsSuccess(false)
    const token = await refreshTokenIfExpired()
    if (testMyself) {
      await axios.post(
        `${API_BASE_URL}/api/v1/extensions/revision/record/stop_recording/${recordingId}?test_myself=true`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
    } else {
      await axios.post(
        `${API_BASE_URL}/api/v1/extensions/revision/record/stop_recording/${recordingId}?test_myself=false`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
    }
    timeoutId = setTimeout(async () => {
      await getRecordings({ testMyself: testMyself }).unwrap()
      setIsSuccess(true)
    }, 1500)
  }

  React.useEffect(() => {
    if (isSuccess && timeoutId) {
      clearTimeout(timeoutId)
      timeoutId = null
    }
  }, [isSuccess])

  return { isSuccess, uploadRecording, stopUploadRecording }
}
